module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gotu-nav-button', {
    class: [_vm.$style.root, _vm.wide ? "wide" : "not-wide"],
    attrs: {
      "theme": "default-cta",
      "disabled": _vm.sending
    },
    on: {
      "click": _vm.trigger
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78233bca"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/trigger-notification/TriggerNotification.vue
// module id = 2065
// module chunks = 1